import {cn} from '@ds/helpers';

import {GRADES} from './constants';

type VendorGradeBadgeProps = {
  grade: string;
};

const VendorGradeBadge: React.FC<VendorGradeBadgeProps> = ({grade}) => {
  const gradeData = GRADES[grade];

  if (!gradeData) {
    return null;
  }

  const {Icon, borderClassName, containerClassName, label, labelClassName} = gradeData;

  const content = (
    <span
      className={cn('flex items-center rounded-lg px-3.75 py-0.5 shadow-sm', containerClassName)}
    >
      <Icon aria-hidden />
      <span className={labelClassName}>{label}</span>
    </span>
  );

  return (
    <button
      type="button"
      className={cn('w-full rounded-lg text-body-sm', borderClassName)}
      onClick={() =>
        window.open('https://snappmarket.landin.ir/academy/', '_blank', 'noopener,noreferrer')
      }
    >
      {content}
    </button>
  );
};

export default VendorGradeBadge;
